import { render, staticRenderFns } from "./materials_details.vue?vue&type=template&id=1d138145&scoped=true&"
import script from "./materials_details.vue?vue&type=script&lang=js&"
export * from "./materials_details.vue?vue&type=script&lang=js&"
import style0 from "./materials_details.vue?vue&type=style&index=0&id=1d138145&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d138145",
  null
  
)

export default component.exports